import { Component, Input, OnInit } from '@angular/core';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'cx-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, NgClass, RouterLink]
})
export class BreadcrumbComponent implements OnInit {
  @Input() breadcrumb: {
    title: string,
    uri?: string[]
  }[]

  constructor() { }

  ngOnInit(): void {
  }

}
